import { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";

const links = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <nav
        className={`sticky top-0 z-50 backdrop-blur-md bg-white/80 transition-shadow duration-300 ${
          scrolled ? "shadow-md" : "shadow-none"
        }`}
      >
        <div className="max-w-6xl mx-auto flex justify-between items-center px-6 py-4">
          <a href="#home" className="flex items-center gap-2">
            <img src="/logo-nav.png" alt="MOHD SAZID KHAN" className="h-9 md:h-11 w-auto" />
          </a>

          <div className="hidden md:flex items-center gap-8">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="relative text-sm font-medium text-gray-700 hover:text-indigo-600 transition after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:w-0 after:bg-indigo-600 after:transition-all hover:after:w-full"
              >
                {link.label}
              </a>
            ))}
          </div>

          {!open && (
            <div className="flex items-center gap-3 md:hidden">
              <button
                onClick={() => setOpen(true)}
                aria-label="Open menu"
                className="text-xl text-gray-800"
              >
                <FaBars />
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Full-width slide-in menu */}
      <div
        className={`fixed inset-0 z-50 w-full h-full bg-white transform transition-transform duration-300 ease-out md:hidden ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <img src="/logo-nav.png" alt="MOHD SAZID KHAN" className="h-9 w-auto" />
          <button
            onClick={() => setOpen(false)}
            aria-label="Close menu"
            className="text-xl text-gray-800"
          >
            <FaTimes />
          </button>
        </div>

        <div className="flex flex-col px-6 py-4">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="py-4 text-lg font-medium text-gray-700 border-b border-gray-50 hover:text-indigo-600 transition"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </>
  );
}
